export const AUTH_ROUTE_NAMES = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  ACTION: 'action',
  REGISTER: 'register',
  RESETPASSWORD : 'reset-password',
  PROFILE: 'my-profile'
//{ROUTE_NAME}
};
